import {cn} from '@utilities/helpers'
import {FC, ReactNode} from 'react'

interface IconContainerProps {
    children: ReactNode
    size?: 'md' | 'lg'
}
export const IconContainer: FC<IconContainerProps> = ({children, size = 'md'}) => {
    return (
        <div
            className={cn(
                'border border-neutral-200 rounded-xl flex justify-center items-center',
                size === 'lg' ? 'size-12 [&_svg]:size-6' : 'size-10 [&_svg]:size-5'
            )}
        >
            {children}
        </div>
    )
}

IconContainer.displayName = 'IconContainer'
